import { IPageInSearch } from '@/shared/searchProvider/types';
import { normalizeSitemapProperty, normalizeUri } from '../utils';
import { SitemapProperty } from './sitemap-property.enum';
import { CoveoResultProperty, ICoveoResultForPage } from './types';

class CoveoPageService {
  transform(result: ICoveoResultForPage): IPageInSearch {
    const uri = result[CoveoResultProperty.Uri];
    const data = result[CoveoResultProperty.Raw];

    return {
      imageUrl: data[SitemapProperty.LOGO_URL],
      name: normalizeSitemapProperty(data[SitemapProperty.PAGE_NAME]),
      description: normalizeSitemapProperty(data[SitemapProperty.SHORT_DESC]),
      path: normalizeUri(uri),
      pageId: data[SitemapProperty.PAGE_ID],
      vanityUrl: '',
    };
  }
}

export const coveoPageService = new CoveoPageService();
